import { httpRequest } from "../../http"

export class CommandUpdateEngagementStatus {
  async run(engagementId: number, status: string) {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/${engagementId}/`
    try {
      const response = await httpRequest<any>(url, {
        method: "PATCH",
        body: {
          status,
        },
      })

      return response
    } catch (error) {
      console.error("Error updating engagement status:", error)
      throw error
    }
  }
}
